module.exports = __webpack_public_path__ + "static/media/Ansarada Board Admin Portal demoSM.38914a5b.mp4";